import './styles/component.accordion.scss';
import { isNullOrUndef } from '../utils/isNullOrUndef';
import { eventTransitionEndByHeight } from '../js/helpers/eventTransitionEndByHeight';
import { isNotNullOrUndef } from '../utils/isNotNullOrUndef';
class ComponentAccordion extends HTMLElement {
    accordionsInGroup = [];
    button = null;
    wrapper = null;
    connectedCallback() {
        this.button = this.querySelector('[aria-controls]');
        this.wrapper = this.querySelector(`#${this.button?.getAttribute('aria-controls') ?? 'null'}`);
        if (isNotNullOrUndef(this.dataset.accordionGroup)) {
            this.accordionsInGroup = [...document.querySelectorAll(`accordion-component[data-accordion-group="${this.dataset.accordionGroup}"]`)];
        }
        else {
            this.accordionsInGroup = [];
        }
        this.button?.addEventListener('click', (event) => {
            event.preventDefault();
            if (isNullOrUndef(this.button))
                return;
            if (this.button.getAttribute('aria-expanded') === 'false') {
                this.expand();
            }
            else {
                this.collapse();
            }
        });
    }
    expand() {
        if (isNullOrUndef(this.button) || isNullOrUndef(this.wrapper))
            return;
        this.button.setAttribute('aria-expanded', 'true');
        this.wrapper.style.height = isNullOrUndef(this.wrapper.firstElementChild)
            ? 'auto'
            : `${this.wrapper.firstElementChild.scrollHeight}px`;
        this.wrapper.setAttribute('data-state-expanded', 'true');
        this.wrapper.addEventListener('transitionend', eventTransitionEndByHeight);
        if (this.accordionsInGroup.length > 0) {
            this.accordionsInGroup.forEach((accordion) => {
                if (accordion !== this) {
                    accordion.collapse();
                }
            });
        }
    }
    collapse() {
        if (isNullOrUndef(this.button) || isNullOrUndef(this.wrapper))
            return;
        this.button.setAttribute('aria-expanded', 'false');
        this.wrapper.style.height = `${this.wrapper.scrollHeight}px`;
        if (this.wrapper.scrollHeight > 0) {
            this.wrapper.style.height = '0';
        }
        this.wrapper.setAttribute('data-state-expanded', 'false');
        this.wrapper.addEventListener('transitionend', eventTransitionEndByHeight);
    }
}
customElements.define('accordion-component', ComponentAccordion);
